export default "__VITE_ASSET__CzMt1uAF__"